import { useMutation, useQuery } from "@tanstack/react-query";
import client from "./client";
import { useNotifications } from "reapop";
import { queryClient } from "queryclient";
import { useNavigate } from "react-router-dom";

export const CreateAccreditationMutation = () => {
  const { notify } = useNotifications();
  const navigate = useNavigate();
  const accreditations = useMutation({
    mutationFn: (data) => client.accreditations.addAccreditations(data),
    onSuccess: () => {
      notify("Details Added Successfully", "success");
      queryClient.invalidateQueries({ queryKey: ["get-all-accreditations"] });
      navigate("/accreditations");
    },
    onError: () => notify("OOPS! some error occured", "error"),
  });
  return accreditations;
};

export const GetAllAccreditationMutation = () => {
  const accreditations = useQuery({
    queryKey: ["get-all-accreditations"],
    queryFn: () => client.accreditations.getAccreditations(),
  });
  return accreditations;
};

export const GetSingleAccreditationMutation = (id) => {
  const accreditations = useQuery({
    queryKey: ["get-single-accreditations"],
    queryFn: () => client.accreditations.getSingleAccreditations(id),
  });
  return accreditations;
};

export const EditAccreditationMutation = (id) => {
  const { notify } = useNotifications();
  const navigate = useNavigate();
  const accreditations = useMutation({
    mutationFn: (data) => client.accreditations.editAccreditations(data, id),
    onSuccess: () => {
      notify("Details Updated Successfully", "success");
      queryClient.invalidateQueries({ queryKey: ["get-all-accreditations"] });
      navigate("/accreditations");
    },
    onError: () => notify("OOPS! some error occured", "error"),
  });
  return accreditations;
};

export const DeleteAccreditationMutation = () => {
  const { notify } = useNotifications();
  const navigate = useNavigate();
  const accreditations = useMutation({
    mutationFn: (id) => client.accreditations.deleteAccreditations(id),
    onSuccess: () => {
      notify("Details deleted Successfully", "success");
      queryClient.invalidateQueries({ queryKey: ["get-all-accreditations"] });
      navigate("/accreditations");
    },
    onError: () => notify("OOPS! some error occured", "error"),
  });
  return accreditations;
};

export const GetAccreditationsExploreHeading = () => {
  return useQuery({
    queryKey: ["get-accreditations-explore-heading"],
    queryFn: () => client.accreditations.getAccreditationsExploreHeading(),
  });
};

export const UpdateAccreditationsExploreHeading = () => {
  const { notify } = useNotifications();
  return useMutation({
    mutationFn: (data) => client.accreditations.updateAccreditationsExploreHeading(data),
    onSuccess: () => {
      notify("Heading updated successfully", "success");
      queryClient.invalidateQueries({ queryKey: ["get-accreditations-explore-heading"] });
    },
    onError: () => notify("OOPS! something went wrong", "error"),
  });
};

export const GetAllAccreditationsExploreLinks = () => {
  return useQuery({
    queryKey: ["get-all-accreditations-explore-links"],
    queryFn: () => client.accreditations.getAllAccreditationsExploreLinks(),
  });
};

export const CreateAccreditationsExploreLink = () => {
  const { notify } = useNotifications();
  return useMutation({
    mutationFn: (data) => client.accreditations.newAccreditationsExploreLink(data),
    onSuccess: () => {
      notify("Link added successfully", "success");
      queryClient.invalidateQueries({ queryKey: ["get-all-accreditations-explore-links"] });
    },
    onError: () => notify("OOPS! something went wrong", "error"),
  });
};

export const UpdateAccreditationsExploreLink = () => {
  const { notify } = useNotifications();
  return useMutation({
    mutationFn: (data) => client.accreditations.updateAccreditationsExploreLink(data),
    onSuccess: () => {
      notify("Link updated successfully", "success");
      queryClient.invalidateQueries({ queryKey: ["get-all-accreditations-explore-links"] });
    },
    onError: () => notify("OOPS! something went wrong", "error"),
  });
};

export const DeleteAccreditationsExploreLink = () => {
  const { notify } = useNotifications();
  return useMutation({
    mutationFn: (data) => client.accreditations.deleteAccreditationsExploreLink(data),
    onSuccess: () => {
      notify("Link deleted successfully", "success");
      queryClient.invalidateQueries({ queryKey: ["get-all-accreditations-explore-links"] });
    },
    onError: () => notify("OOPS! something went wrong", "error"),
  });
};
